module.exports = __webpack_public_path__ + "img/View Property.b3cd0481.svg";